import {ReturnReason} from "../models/types";
import {useQuery} from "react-query";
import {retrieveReturnReasons} from "../restapi/return-reason";
import {ServerError} from "../models/types";

export function useRetrieveReturnReasons({onError}: {onError?: (e: ServerError) => void}): ReturnReason[] | undefined {
    const returnReasonsQuery = useQuery(['ReturnReasons'], () => retrieveReturnReasons(), {onError: onError});
    return returnReasonsQuery.data;
}
